import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useAuth } from '../../auth/AuthProvider';
import { hasPermission, PERMISSIONS } from '../../auth/permissions';
import { colors, radius, shadows } from '../../styles/theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const getToken = () => localStorage.getItem('access_token');
const authHeaders = () => ({ 'Authorization': `Bearer ${getToken()}` });
const fmt = (n) => (n || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 });

const th = { padding: '6px 8px', textAlign: 'left', fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.3px', fontWeight: 700, color: '#555', borderBottom: '2px solid #ddd' };
const thR = { ...th, textAlign: 'right' };
const td = { padding: '6px 8px', fontSize: 11 };
const tdR = { ...td, textAlign: 'right' };

// ============ Aylık Gider Özeti ============
const GiderOzetRapor = ({ ciroPayiAktif }) => {
  const [yil, setYil] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/raporlar/ik/personel-gider-ozet?ay_start=${yil}-01&ay_end=${yil}-12`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : [])
      .then(d => { setData(d); setLoading(false); });
  }, [yil]);

  return (
    <div style={{ background: colors.surface, borderRadius: radius.md, padding: 16, boxShadow: shadows.sm }}>
      <div style={{ marginBottom: 14 }}>
        Yıl: <input type="number" min="2024" max="2030" value={yil} onChange={e => setYil(parseInt(e.target.value))} style={{ padding: 8, border: `1px solid ${colors.border}`, borderRadius: 4, width: 100 }} />
      </div>
      {loading ? <div>Yükleniyor...</div> : data.length === 0 ? <div style={{ color: '#888', padding: 20 }}>Kayıt yok (henüz kapatılmış puantaj yok)</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
            <thead><tr style={{ background: '#f5f5f5' }}>
              <th style={th}>Ay</th>
              <th style={th}>Lokasyon</th>
              <th style={thR}>Personel</th>
              <th style={thR}>Toplam Hakediş</th>
              <th style={thR}>Tam Maliyet (P&L)</th>
              <th style={thR}>Bankadan</th>
              <th style={thR}>Elden (Nihai)</th>
              <th style={thR}>Avans</th>
              {ciroPayiAktif && <th style={thR}>Ciro Payı</th>}
            </tr></thead>
            <tbody>
              {data.map((o, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{o.ay}</td>
                  <td style={td}>{o.lokasyon_ad}</td>
                  <td style={tdR}>{o.personel_sayisi}</td>
                  <td style={tdR}>{fmt(o.toplam_brut)} ₺</td>
                  <td style={{ ...tdR, fontWeight: 700, color: '#1565c0' }}>{fmt(o.tam_maliyet)} ₺</td>
                  <td style={tdR}>{fmt(o.bankadan)} ₺</td>
                  <td style={{ ...tdR, fontWeight: 700, color: '#2e7d32' }}>{fmt(o.elden)} ₺</td>
                  <td style={tdR}>{fmt(o.avans)} ₺</td>
                  {ciroPayiAktif && <td style={tdR}>{fmt(o.ciro_payi)} ₺</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// ============ Yıllık Trend ============
const AYLAR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
const YillikTrendRapor = () => {
  const [yil, setYil] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/raporlar/ik/personel-gider-yillik?yil=${yil}`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(setData);
  }, [yil]);

  const maxVal = data ? Math.max(...data.aylar.map(a => a.toplam_nihai), 1) : 1;
  const yillikToplam = data ? data.aylar.reduce((s, a) => s + a.toplam_nihai, 0) : 0;

  return (
    <div style={{ background: colors.surface, borderRadius: radius.md, padding: 16, boxShadow: shadows.sm }}>
      <div style={{ marginBottom: 14 }}>
        Yıl: <input type="number" value={yil} onChange={e => setYil(parseInt(e.target.value))} style={{ padding: 8, border: `1px solid ${colors.border}`, borderRadius: 4, width: 100 }} />
      </div>
      {!data ? <div>Yükleniyor...</div> : (
        <>
          <div style={{ marginBottom: 16, fontSize: 14, color: '#555' }}>
            <strong>{yil} Yılı Toplam Personel Gideri: <span style={{ color: '#2e7d32' }}>{fmt(yillikToplam)} ₺</span></strong>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', height: 220, marginBottom: 20, padding: '0 20px' }}>
            {data.aylar.map((a, i) => {
              const h = maxVal > 0 ? (a.toplam_nihai / maxVal * 180) : 0;
              return (
                <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{ fontSize: 10, color: '#666', marginBottom: 2 }}>{a.toplam_nihai > 0 ? `${fmt(a.toplam_nihai / 1000)}k` : ''}</div>
                  <div style={{ width: '80%', height: Math.max(h, 2), background: a.toplam_nihai > 0 ? '#1565c0' : '#e0e0e0', borderRadius: '3px 3px 0 0', transition: 'height 0.3s' }} />
                  <div style={{ fontSize: 11, color: '#333', marginTop: 4, fontWeight: 600 }}>{AYLAR[i]}</div>
                </div>
              );
            })}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
            <thead><tr style={{ background: '#f5f5f5' }}>
              <th style={th}>Ay</th>
              <th style={thR}>Personel</th>
              <th style={thR}>Bankadan</th>
              <th style={thR}>Elden</th>
              <th style={thR}>Toplam Nihai</th>
            </tr></thead>
            <tbody>
              {data.aylar.map((a, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{AYLAR[i]} {yil}</td>
                  <td style={tdR}>{a.personel_sayisi}</td>
                  <td style={tdR}>{fmt(a.bankadan)} ₺</td>
                  <td style={tdR}>{fmt(a.elden)} ₺</td>
                  <td style={{ ...tdR, fontWeight: 700, color: '#2e7d32' }}>{fmt(a.toplam_nihai)} ₺</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: '#fafafa', fontWeight: 700 }}>
                <td style={td}>TOPLAM {yil}</td>
                <td style={tdR}>-</td>
                <td style={tdR}>{fmt(data.aylar.reduce((s, a) => s + a.bankadan, 0))} ₺</td>
                <td style={tdR}>{fmt(data.aylar.reduce((s, a) => s + a.elden, 0))} ₺</td>
                <td style={{ ...tdR, color: '#2e7d32' }}>{fmt(yillikToplam)} ₺</td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </div>
  );
};

// ============ İzin Durumu ============
const IzinDurumRapor = () => {
  const [yil, setYil] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/raporlar/ik/izin-durum?yil=${yil}`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : [])
      .then(d => { setData(d); setLoading(false); });
  }, [yil]);

  return (
    <div style={{ background: colors.surface, borderRadius: radius.md, padding: 16, boxShadow: shadows.sm }}>
      <div style={{ marginBottom: 14 }}>
        Yıl: <input type="number" value={yil} onChange={e => setYil(parseInt(e.target.value))} style={{ padding: 8, border: `1px solid ${colors.border}`, borderRadius: 4, width: 100 }} />
      </div>
      {loading ? <div>Yükleniyor...</div> : data.length === 0 ? <div style={{ color: '#888', padding: 20 }}>Aktif personel yok</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
            <thead><tr style={{ background: '#f5f5f5' }}>
              <th style={th}>Personel</th>
              <th style={th}>Lokasyon</th>
              <th style={th}>İşe Giriş</th>
              <th style={thR}>Yıllık Hak</th>
              <th style={thR}>Kullanılan</th>
              <th style={thR}>Kalan</th>
              <th style={thR}>Mazeret</th>
              <th style={thR}>Rapor</th>
              <th style={thR}>Ücretsiz</th>
            </tr></thead>
            <tbody>
              {data.map((d) => (
                <tr key={d.personel_id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{d.personel_ad}</td>
                  <td style={td}>{d.lokasyon_ad || '-'}</td>
                  <td style={td}>{d.ise_giris_tarihi || '-'}</td>
                  <td style={tdR}>{d.yillik_hak}</td>
                  <td style={tdR}>{d.yillik_kullanilan}</td>
                  <td style={{ ...tdR, fontWeight: 700, color: d.yillik_kalan <= 0 ? '#c62828' : d.yillik_kalan < 5 ? '#e65100' : '#2e7d32' }}>{d.yillik_kalan}</td>
                  <td style={tdR}>{d.mazeret}</td>
                  <td style={tdR}>{d.rapor}</td>
                  <td style={tdR}>{d.ucretsiz}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// ============ Ciro Payı Geçmişi ============
const CiroGecmisRapor = () => {
  const [lokId, setLokId] = useState(4);
  const [lokasyonlar, setLokasyonlar] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/lokasyonlar`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : [])
      .then(l => setLokasyonlar(l.filter(x => x.aktif !== false)));
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/api/raporlar/ik/ciro-payi-gecmisi?lokasyon_id=${lokId}`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : [])
      .then(setData);
  }, [lokId]);

  return (
    <div style={{ background: colors.surface, borderRadius: radius.md, padding: 16, boxShadow: shadows.sm }}>
      <div style={{ marginBottom: 14 }}>
        Lokasyon: <select value={lokId} onChange={e => setLokId(parseInt(e.target.value))} style={{ padding: 8, border: `1px solid ${colors.border}`, borderRadius: 4 }}>
          {lokasyonlar.map(l => <option key={l.id} value={l.id}>{l.ad}</option>)}
        </select>
      </div>
      {data.length === 0 ? <div style={{ color: '#888' }}>Bu lokasyonda kapatılmış ciro payı hesabı yok</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
            <thead><tr style={{ background: '#f5f5f5' }}>
              <th style={th}>Ay</th>
              <th style={thR}>Aylık Ciro</th>
              <th style={thR}>Havuz Toplam</th>
              <th style={thR}>Servis</th>
              <th style={thR}>Mutfak</th>
              <th style={thR}>Kişi Sayısı</th>
              <th style={thR}>Kişi Başı Ort.</th>
            </tr></thead>
            <tbody>
              {data.map((d, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{d.ay}</td>
                  <td style={tdR}>{fmt(d.aylik_ciro)} ₺</td>
                  <td style={{ ...tdR, fontWeight: 700 }}>{fmt(d.havuz_toplam)} ₺</td>
                  <td style={tdR}>{fmt(d.servis_havuz)} ₺ <span style={{ color: '#888', fontSize: 10 }}>({d.servis_kisi})</span></td>
                  <td style={tdR}>{fmt(d.mutfak_havuz)} ₺ <span style={{ color: '#888', fontSize: 10 }}>({d.mutfak_kisi})</span></td>
                  <td style={tdR}>{d.kisi_sayisi}</td>
                  <td style={{ ...tdR, color: '#1565c0', fontWeight: 600 }}>{fmt(d.kisi_basi_ortalama)} ₺</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// ============ Demografi ============
const KartStili = { background: colors.surface, borderRadius: radius.md, padding: 16, boxShadow: shadows.sm };

const OzetKart = ({ etiket, deger, uyari }) => (
  <div style={{ flex: 1, ...KartStili, textAlign: 'center' }}>
    <div style={{ fontSize: 11, color: '#777', textTransform: 'uppercase', letterSpacing: '0.4px', fontWeight: 600 }}>{etiket}</div>
    <div style={{ fontSize: 28, fontWeight: 700, color: uyari ? '#e65100' : '#1565c0', marginTop: 6 }}>{deger}</div>
    {uyari && <div style={{ fontSize: 10, color: '#e65100', marginTop: 4 }}>{uyari}</div>}
  </div>
);

const BarChart = ({ baslik, veri, renkler }) => {
  const max = Math.max(...Object.values(veri), 1);
  return (
    <div style={KartStili}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#333', marginBottom: 14 }}>{baslik}</div>
      {Object.entries(veri).map(([kova, sayi], i) => {
        const yuzde = max > 0 ? (sayi / max * 100) : 0;
        const renk = renkler[i % renkler.length];
        return (
          <div key={kova} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <div style={{ width: 60, fontSize: 11, color: '#555', fontWeight: 600 }}>{kova}</div>
            <div style={{ flex: 1, background: '#f0f0f0', borderRadius: 4, height: 22, position: 'relative', overflow: 'hidden' }}>
              <div style={{ width: `${yuzde}%`, height: '100%', background: renk, borderRadius: 4, transition: 'width 0.3s' }} />
              <div style={{ position: 'absolute', left: 8, top: 3, fontSize: 11, color: '#333', fontWeight: 600 }}>{sayi}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const DemografiRapor = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/hr/raporlar/demografi`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(d => { setData(d); setLoading(false); });
  }, []);

  if (loading) return <div style={KartStili}>Yükleniyor...</div>;
  if (!data) return <div style={KartStili}>Veri yüklenemedi.</div>;

  const dogumTarihiEksik = data.toplam_aktif - data.dogum_tarihi_var;
  const yasRenkleri = ['#42a5f5', '#66bb6a', '#ffa726', '#ef5350'];
  const kidemRenkleri = ['#ab47bc', '#5c6bc0', '#26a69a', '#ff7043'];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {/* Özet kartlar */}
      <div style={{ display: 'flex', gap: 14 }}>
        <OzetKart etiket="Toplam Aktif Personel" deger={data.toplam_aktif} />
        <OzetKart etiket="Ortalama Yaş" deger={data.ortalama_yas != null ? data.ortalama_yas : '-'} />
        <OzetKart
          etiket="Doğum Tarihi Eksik"
          deger={dogumTarihiEksik}
          uyari={dogumTarihiEksik > 0 ? `${dogumTarihiEksik} personelin doğum tarihi girilmemiş` : null}
        />
      </div>

      {/* Yaş piramidi + kıdem dağılımı yan yana */}
      <div style={{ display: 'flex', gap: 14 }}>
        <div style={{ flex: 1 }}>
          <BarChart baslik="Yaş Dağılımı" veri={data.yas_dagilimi} renkler={yasRenkleri} />
        </div>
        <div style={{ flex: 1 }}>
          <BarChart baslik="Kıdem Dağılımı" veri={data.kidem_dagilimi} renkler={kidemRenkleri} />
        </div>
      </div>

      {/* En genç / en yaşlı kartları */}
      <div style={{ display: 'flex', gap: 14 }}>
        <div style={{ flex: 1, ...KartStili }}>
          <div style={{ fontSize: 11, color: '#777', textTransform: 'uppercase', letterSpacing: '0.4px', fontWeight: 600, marginBottom: 6 }}>En Genç</div>
          {data.en_genc ? (
            <>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#2e7d32' }}>{data.en_genc.ad_soyad}</div>
              <div style={{ fontSize: 13, color: '#555' }}>{data.en_genc.yas} yaşında</div>
            </>
          ) : <div style={{ color: '#888' }}>-</div>}
        </div>
        <div style={{ flex: 1, ...KartStili }}>
          <div style={{ fontSize: 11, color: '#777', textTransform: 'uppercase', letterSpacing: '0.4px', fontWeight: 600, marginBottom: 6 }}>En Yaşlı</div>
          {data.en_yasli ? (
            <>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#6a1b9a' }}>{data.en_yasli.ad_soyad}</div>
              <div style={{ fontSize: 13, color: '#555' }}>{data.en_yasli.yas} yaşında</div>
            </>
          ) : <div style={{ color: '#888' }}>-</div>}
        </div>
      </div>

      {/* Lokasyon ortalama kıdem tablosu */}
      <div style={KartStili}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#333', marginBottom: 12 }}>Lokasyon Bazlı Ortalama Kıdem</div>
        {data.lokasyon_ortalama_kidem.length === 0 ? (
          <div style={{ color: '#888', padding: 10 }}>Gösterilecek lokasyon yok.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead><tr style={{ background: '#f5f5f5' }}>
              <th style={th}>Lokasyon</th>
              <th style={thR}>Personel Sayısı</th>
              <th style={thR}>Ortalama Kıdem (Yıl)</th>
            </tr></thead>
            <tbody>
              {data.lokasyon_ortalama_kidem.map(l => (
                <tr key={l.lokasyon_id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{l.lokasyon_ad}</td>
                  <td style={tdR}>{l.personel_sayisi}</td>
                  <td style={{ ...tdR, fontWeight: 700, color: '#1565c0' }}>{l.ortalama_yil}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

// ============ Ana sayfa ============
const IkRaporlarPage = () => {
  const { user } = useAuth();
  const canManage = user && hasPermission(user.role, PERMISSIONS.MANAGE_HR, user.effectivePermissions);
  const [activeTab, setActiveTab] = useState('gider-ozet');
  // Faz D: ciro payı global bayrağı askıda olabilir → Ciro Payı Geçmişi raporu gizlenir. Bilinene kadar gizle.
  const [ciroPayiAktif, setCiroPayiAktif] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/ik/ayarlar`, { headers: authHeaders() })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setCiroPayiAktif(!!d.ciro_payi_aktif); })
      .catch(() => {});
  }, []);

  if (!canManage) {
    return <div><Header title="İK Raporları" /><div style={{ padding: 40, textAlign: 'center' }}>Yetkiniz yok.</div></div>;
  }

  const tabs = [
    { id: 'gider-ozet', label: 'Aylık Gider Özeti' },
    { id: 'yillik-trend', label: 'Yıllık Trend' },
    { id: 'izin-durum', label: 'İzin Durumu' },
    { id: 'ciro-gecmis', label: 'Ciro Payı Geçmişi' },
    { id: 'demografi', label: 'Demografi' },
  ].filter(t => t.id !== 'ciro-gecmis' || ciroPayiAktif);

  return (
    <div>
      <Header title="İK Raporları" />
      <div style={{ padding: 20, background: colors.background, minHeight: 'calc(100vh - 60px)' }}>
        <div style={{ background: colors.surface, borderRadius: radius.md, marginBottom: 14, display: 'flex', gap: 0, boxShadow: shadows.sm, overflow: 'hidden' }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)} style={{
              flex: 1,
              padding: '14px 20px',
              background: activeTab === t.id ? '#1565c0' : 'transparent',
              color: activeTab === t.id ? 'white' : '#555',
              border: 'none',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 11,
              transition: 'background 0.2s',
            }}>
              {t.label}
            </button>
          ))}
        </div>

        {activeTab === 'gider-ozet' && <GiderOzetRapor ciroPayiAktif={ciroPayiAktif} />}
        {activeTab === 'yillik-trend' && <YillikTrendRapor />}
        {activeTab === 'izin-durum' && <IzinDurumRapor />}
        {activeTab === 'ciro-gecmis' && ciroPayiAktif && <CiroGecmisRapor />}
        {activeTab === 'demografi' && <DemografiRapor />}
      </div>
    </div>
  );
};

export default IkRaporlarPage;
